import React from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';

interface ProductDescriptionModalProps {
  show: boolean;
  description: string;
  productDonHide: () => void;
}

const ProductDescriptionModal: React.FC<ProductDescriptionModalProps> = ({ productDonHide, ...props }) => {

  const { t } = useTranslation();

  return (
    <Modal
      {...props}
      aria-labelledby="product-description-modal"
      centered
      size="lg"
      onHide={productDonHide}
      className='product-description-modal'
    >
      <Modal.Header closeButton>
        <Modal.Title id="product-description-modal">
          {t('product-description')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='product-description-wrapper'>
          <p>{props.description}</p>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ProductDescriptionModal